import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  IconButton,
  Box,
  Typography,
  useTheme,
  CircularProgress,
  Grid,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

const AdminWidget = ({
  title,
  onRefresh,
  children,
  lastUpdated,
  loading = false,
  disableRefresh = false,
  height = "short",   // default
  width = "half",     // default
}) => {
  const theme = useTheme();

  const formatTime = (date) => {
    if (!date) return null;
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  };

  // Width → Grid breakpoints
  const widthMap = {
    full: { xs: 12 },
    half: { xs: 12, md: 6 },
    third: { xs: 12, md: 4 },
    twoThirds: { xs: 12, md: 8 },
  };
  
  // Fallbacks in case of invalid values
  const gridProps = widthMap[width] || widthMap.half;

  return (
    <Grid item {...gridProps}>
      <Card
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          minHeight: height === "short" ? 300 : 500,
          maxHeight: height === "short" ? 300 : 500,
        }}
      >

        <CardHeader
          title={
            <Box>
              <Typography variant="h6" sx={{ color: theme.palette.accent.main }}>
                {title}
              </Typography>
              {lastUpdated && (
                <Typography variant="caption" color="text.secondary">
                  Last updated: {formatTime(lastUpdated)}
                </Typography>
              )}
            </Box>
          }
          action={
            onRefresh && (
              <IconButton onClick={onRefresh} disabled={disableRefresh || loading}>
                <RefreshIcon />
              </IconButton>
            )
          }
        />
        <CardContent
          sx={{
            flex: 1,
            overflowY: "auto",
            "&::-webkit-scrollbar": { width: "6px" },
            "&::-webkit-scrollbar-track": { background: "transparent" },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: theme.palette.divider,
              borderRadius: "3px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: theme.palette.text.secondary,
            },
          }}
        >
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress size={30} />
            </Box>
          ) : (
            children
          )}
        </CardContent>
      </Card>
    </Grid>
  );
};

export default AdminWidget;